export default "__VITE_ASSET__D0qTL_P4__"